<template>
  <div>

     <div class="container-fluid w-100">
      <div class="row ">
        <div class="col-12  px-lg-0">
          <lotto-results-slider v-if="true" class="w-100" />
        </div>
      </div>
    </div>
    
    <!-- stream -->
    <div class="container-fluid w-100">
      <div class="row">

        <div v-if="$store.state.authToken" class="col-12 px-lg-0 w-100">
          <lotto-streams/>
        </div>
      </div>
    </div>

    <pre-loader v-if="loading" />
    <div v-show="!loading"> 

      <no-events v-if="!lottos?.events?.length" :title="sport.title" is-relative class="my-4"/>
      <div v-else>
        
        <div class="container-fluid ">
          <div class="row">
            <div class="col-12 order-2 col-lg-5 order-lg-1 mb-2 ps-lg-0">
              <div class="res-card p-n">
                <div class="balls-wr">
                    <lotto-ball-number 
                      v-for="num in selectedBalls"
                      :key="num"
                      :class="{ 'faded grey': !num, 'desk-c-pointer': !!num }"
                      :number="parseInt(num)"
                      @click="removeBallNumber(num)">
                    </lotto-ball-number>
                </div>

                <div class="section-action-wr">
                  <vue-switch show-label v-model="isRetainSelection">Retain Selections</vue-switch>
                </div>
                
                <hr class="geoff-menu-separator"/>

                <!-- EVENT/TIME -->
                <div class="field-2-wr">
                  <vue-select
                    name="time"
                    label-class="hidden"
                    v-model="time"
                    :options="eventOptions"
                  />
                  <div class="d-flex justify-content-end align-items-center">
                    <vue-switch show-label name="booster" v-model="isBooster">Booster</vue-switch>
                  </div>
                </div>

                <div class="mb-2">
                  <div  class="wager-type-wrapper">
                    <div class="fs-14 d-flex justify-content-center align-items-center">{{ selectedWager?.numberOfLines }} lines</div>
                    <select class="wager-type-select flex-grow-1 text-center me-3 fs-20 fw-600 geoff-text-main" v-model="wager">
                      <option class="" v-for="wager in wagerOptions" :key="wager.typeId" :value="wager.typeId">{{wager.name}}</option>
                    </select>
                  </div>
                </div>
                <div class="mb-2">
                  <input placeholder="AMOUNT" type="number" :step="1" class="input-value" v-model="amount">
                </div>

              <!-- SUBMIT -->
                <div>
                  <vue-button 
                    :disabled="!isSubmitAvailable"
                    v-if="$store.state.authToken"
                    :cls="isSubmitAvailable ? 'main' : 'disable'"
                    class="w-100 fs-5 fw-600" @click="submitBet">Place Lotto Bet <span v-if="betTotal" class="fw-500 ms-2">£{{betTotal}}</span><!----></vue-button>
                  <vue-button  v-else cls="main" class="w-100 fs-6 fw-500" @click="$router.push({name: 'login'})">Please Login/Signup to Place the Bet</vue-button>
                </div>
              </div>
            </div> 
            
            <div class="col-12 order-1 col-lg-7 order-lg-2 mb-2 px-lg-0 h-100-XXX"> <!--ps-lg-0-->
              <lotto-odds-info v-if="oddsInfo" :model="oddsInfo" class="res-card mb-2"/>
              <lotto-event-bet show-lucky show-reset :max-balls="5" v-model="balls" ></lotto-event-bet>
            </div>
          </div>
        </div>
      </div>
    </div>

    <vue-modal ref="submitResponseModal" no-close>
      <template v-slot:default>
        <div v-if="betSlipProcessing" class="d-flex align-items-center justify-content-center">
          <div class="m-5 p-5 d-flex justify-content-center align-items-center flex-column">
            <div style="height: 8rem; width: 8rem" class="position-relative"><pre-loader/></div>
            <div class="fs-20 fw-500 text-center">Wager processing with Geoff Banks.</div>
          </div>
        </div>
        <bet-slip-submit-response
          v-if="submitResponse "
          :betslip-response="submitResponse"
          @updatestatus="updateBetSlipStatus"
          @close="closeSubmitResponse"
          hide-potential-return
          btn-back-label="Close"
          isolated-submit
        />
      </template>
    </vue-modal>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import LottoEventBet from "@/components/Sport/Lotto/LottoEventBet";
import LottoResultsSlider from "@/components/Sport/Lotto/LottoResultsSlider";
import LottoOddsInfo from "@/components/Sport/Lotto/LottoOddsInfo";
import LottoStreams from "@/components/Sport/Lotto/LottoStreams";
import PreLoader from "@/components/UI/PreLoader";
import VueSwitch from "@/components/UI/VueSwitch";
import VueSelect from "@/components/UI/VueSelect";
import VueButton from "@/components/UI/VueButton";

import NoEvents from "@/components/Sport/NoEvents";

import LottoBallNumber from "@/components/UI/LottoBallNumber";

import BetSlipSubmitResponse from "@/components/BetSlip/BetSlipSubmitResponse";
import VueModal from "@/components/UI/VueModal";


export default {
  name: "LottosMain",
  components: {
    NoEvents,
    PreLoader,
    LottoEventBet,
    LottoResultsSlider,
    LottoOddsInfo,
    LottoStreams,
    VueSwitch,
    VueSelect,
    VueButton,
    LottoBallNumber,

    BetSlipSubmitResponse,
    VueModal
  },
  props: ['sport'],
  data:()=>{
    return{
      // loading: true,
      loadingWagers: true,
      loadingEvents: true,
      isRetainSelection: true,
      betSlipProcessing: true,
      isBooster: false,
      time: '', //'12:49',
      amount: null,
      wager: null,
      wagers: [],
      balls:[],
      oddsInfo: null,
      lottos: null,
      submitResponse: null,
      intervalLoad: null,
      streamEvents: null
    }
  },
  computed:{
    ...mapGetters(['isAuthenticated', 'USER']),
    
    loading() {
      return this.loadingWagers || this.loadingEvents
    },

    eventOptions() {
      return this.lottos.events.map(el => el.time)
    },

    selectedBalls() {
      if (this.balls.length === 5) {
        return this.balls
      }

      const result = [... this.balls]
      result[4] = null
      return result
    },
    isSubmitAvailable() {
      return (this.balls.length && this.amount > 0 )
    },
    betTotal() {
      if (this.amount && this.balls?.length) {
        return (this.selectedWager?.numberOfLines * parseFloat(this.amount)).toFixed(2)
      }
      return null
    },
    wagerOptions() {
      const len = this.balls?.length || 1
      return this.wagers.find(el => el.betsCount === len)?.wagers
    },
    selectedWager() {
      return this.wagerOptions?.find(el => el.typeId === this.wager)
    },
  },

  beforeUnmount() {
    if (this.intervalLoad) clearInterval(this.intervalLoad)
  },
  mounted() {
    this.intervalLoad = setInterval(()=>this.loadData(), 5000)
    this.loadData()
    this.loadWagers()
    this.loadOddsInfo()
  },
  watch: {
    balls:  {
      handler(){
        this.verifyWager()
      },
      deep: true
    }
  },
  methods:{
    removeBallNumber(num) {
      this.balls = this.balls.filter(el => el !== num)
    },
    
    loadWagers() {
      this.API.getLottoWagers()
        .then(wagersResp => {
          this.wagers = wagersResp
         
          this.verifyWager()
          this.loadingWagers = false;
        })
        .catch(err => {
          console.log('getLottoWagers load ERROR', err)
        })
    },
    loadOddsInfo(){
      this.API.getLottoOddsInfo()
        .then(resp => {
          this.oddsInfo = resp
        })
        .catch(err => {
          console.log('getLottoOddsInfo load ERROR', err)
        })
    },

    verifyWager() {
      const isSelectedWagerAvailable = this.wagerOptions
        ?.some( el => el.typeId === this.wager)
        
      if (!this.wager || !isSelectedWagerAvailable) {
        this.wager = this.wagerOptions[0]?.typeId
      }
    },

    loadData() {
      this.API.getLottoEvents()
        .then(eventsResp => {
          this.lottos = eventsResp
          const isSelectedTimeAvailable = eventsResp?.events
            ?.map(el => el.time)
            ?.includes(this.time)
          if (!this.time || !isSelectedTimeAvailable) {
            this.time = eventsResp?.events[0]?.time // set first event as selected
          }
          this.loadingEvents = false
        })
        .catch(err => {
          console.log('getLottoEvents load ERROR', err)
        })
    },
    resetState() {
      if (!this.isRetainSelection) {
        this.balls = []
      }
      this.amount = null
    },
    
    submitBet() {
      const eventIds = this.lottos.events.find(el => el.time == this.time);
      const model = {
        eventTime: this.time,
        isBooster: this.isBooster,
        line: this.balls,
        eventIds: this.isBooster ? eventIds?.boosterEventIds : eventIds?.noBoosterEventIds,
        wagers: [
            {
                typeId: this.wager,
                stake: this.amount
            }
        ]

      }
      this.betSlipProcessing = true
      this.$refs.submitResponseModal.open()

      this.API.submitLottoBet(model)
        .then(submitResp => {
          this.submitResponse = submitResp
        })
        .catch(err => {
          this.$refs.submitResponseModal.close()
          this.$toast.error(err)
        })
        .finally(() => {
          this.betSlipProcessing = false;
        })

    },
    closeSubmitResponse(data) {
      if(!data) {
        this.resetState()
      }
      this.$refs.submitResponseModal.close()
      this.submitResponse = null
    },
    updateBetSlipStatus(status) {
      console.log(status)
    }
  }
}
</script>

<style scoped lang="scss">
  .balls-wr {
    display: flex;
    justify-content: center;
    gap: 0.5rem;
    margin-top: 0.5rem;
    margin-bottom: 1rem;

  }

  .field-2-wr {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 0.5rem;
  }

  .list-move{
    transition: transform 0.3s ease;
  }

  .res-card{
    width: auto;
    background-color: var(--geoff-bg-section);
    border-radius: 0.25rem;
  }

  .lotto-select {
    background-color: var(--geoff-bg-section);
    font-size: 0.75rem;
    height: 29px;

    border-radius: 0.25rem;
    border: 1px solid #858585;
    padding-left: 0.5em;
    padding-right: 1.75em;
    width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

    option {
      background-color: transparent;
    }

    &:focus-visible{
      outline: none;
    }
  }

  // moved from betslip
  .wager-type-wrapper{
    display: flex;
    justify-content: space-between;
    height: 3.125rem;
    background: var(--geoff-bg-btn-1);
    border-radius: 4px;
    padding: 0.5rem 1rem;
    width: 100%;

    select{
      height: 100%;
      background: var(--geoff-bg-btn-1);
      border-radius: 4px;
      border: none;

      &:focus-visible{
        outline: none;
      }
    }
  }

  .section-action-wr {
    display: flex;
    gap: 1rem;
    margin-bottom: 0.5rem;

    &:last-child {
      margin-bottom: 0;
    }
  }
</style>